module.exports = __webpack_public_path__ + "static/6-ba50613e26c67d30a785b169931ae413.jpg";